module.exports = __webpack_public_path__ + "images/vlc535006d9c5ca76803496c4786c4fcdb3.png";